module.exports = __webpack_public_path__ + "img/punchEmpty.d5681db0.svg";